import React, {useEffect, useState} from "react";
import TMSearchHeader from "./TMSearchHeader";
import TMSearchResults from "./TMSearchResults";
import FlashMessage from 'react-flash-message'

import axios from 'axios';
import {
    Chip,
    Dialog, Divider,
    LinearProgress, MenuItem, Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import TMDetailSingle from "./TMDetailSingle";

// const TRADEMARK_FETCH_URL = "http://127.0.0.1:8000"
//const TRADEMARK_FETCH_URL = "https://fastapi.mecrazy1.repl.co/tm/"
const TRADEMARK_FETCH_URL = "https://graphdata.khuranaandkhurana.com/tm/"
 
const classes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45]

const match=['Contains','Match with']

const limit = 15;

const TMSearch = () => {
    const [allWordmark ,setallWordmark]=useState([])
    const [isBusy,setIsBusy]=useState(false)
    const [wordmark, setWordmark] = useState('');
    const [filterClass, setFilterClass] = useState('Class');
  const [matchWith,setMatchWith]=useState('Start with');
    const [fetching, setFetching] = useState(false);
    const [loading, setLoading] = useState(false);

    const [trademarks, setTrademarks] = useState([])
    const [offset, setOffset] = useState(0);
    const [count, setCount] = useState(0);
    const [searchedWordmark, setSearchedWordmark] = useState('');

    const [dialog, setDialog] = useState(false);
    const [detailedTrademark, setDetailedTrademark] = useState({});
    
    const fetchTrademarks = (wordmark, offset = 0, class_number = null,match_with='Start with', load_more=false) => {
      //console.log(class_number,'this is class')
      if(class_number==='Class'){
        class_number=1
      };
      setIsBusy(false)
        const params = {
            wordmark: wordmark,
            offset: offset,
            limit:limit,
            class_number:class_number,
            match_with :matchWith,
        }

        if(load_more){
            setLoading(true)
        } else {
            setFetching(true);
        }
        axios.get(TRADEMARK_FETCH_URL, {params})
            .then(res => {
              //alert('GotaData')
                setOffset(res.data.offset)
                setCount(res.data.count)
                setallWordmark(res.data.dataset)
                load_more ? setTrademarks(trademarks.concat(res.data.dataset)) : setTrademarks(res.data.dataset.slice(0,20))
                setSearchedWordmark(res.data.wordmark)
                setFetching(false);
                setLoading(false)
            }).catch(err => {
            setFetching(false)
            setLoading(false)
            setTrademarks([])
            setOffset(0)
            setCount(0)
            setIsBusy(true)
            //alert('Error Happend')
        })
    }

    const handleSearch = () => {
        setTrademarks([])
        //console.log('this is filter',filterClass)
        if(wordmark === ""){
            return
        }
        if (searchedWordmark!=="" && searchedWordmark !== wordmark && filterClass !== 'Class'){
            //console.log('First if')
            setFilterClass(1)
            fetchTrademarks(wordmark, 0, filterClass,matchWith,false)
          
        } else {
            //console.log('FIrsT ELSE')
            fetchTrademarks(wordmark, 0, filterClass,matchWith,false)
        }
      setOffset(0)
    }
  
    // --- MY CHANGE ----//
    
   const handleLoadMore = () => {
        fetchTrademarks(searchedWordmark, offset, null,true,matchWith)
    }

    const openDetail = (trademark) => {
        setDetailedTrademark(trademark)
        setDialog(true);
    }

  {/*useEffect(() => {
        // ON CLASS CHANGE
        handleSearch()
    }, [filterClass])*/}


    return (
        <div className='flex flex-col'>
          {isBusy && <FlashMessage duration={5000} persistOnHover={true}>
  <p class="fixed z-50 left-0 right-0 ml-auto mr-auto w-4/12 top-10 text-center font-bold bg-red-600 rounded-lg text-white p-2"  style={{color:"#756e15","background-color":"#fffbd1"}}><i class="ico">&#9888;</i> Server Busy !</p>
</FlashMessage>}
            <TMSearchHeader fetching={fetching}
                            wordmark={wordmark}
                            setWordmark={setWordmark}
                            onSubmit={handleSearch}/>

         

            <div className="sticky top-0 bg-white shadow">
                <Divider/>
                
                <div className='h-1'>
                    {fetching && <LinearProgress className=''/>}
                </div>
                <Chip style={{cursor:'pointer'}} label='Register your Trade Mark' color={"primary"} component={'a'} target={'_blank'}
                          href='https://www.khuranaandkhurana.com/trademark-requisition-form/' className=' w-2/5 cursor-pointer mt-2 mb-1 ml-1 shadow-lg hover:shadow-sm'/>
                <div className='flex flex-row px-4 py-2 pb-3'>
                    <div className='flex flex-row p-2 flex-1'>
                        <p className='pt-1'>Filter by</p>
                        <Select value={filterClass}
                                className='ml-4 mr-2'
                                defaultValue={'Class'}
                                onChange={(e) => setFilterClass(e.target.value)}>
                            <MenuItem key='Class' value={'Class'}>Class</MenuItem>
                            {classes.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                        </Select>
                    

                  <div className='flex flex-row flex-1'>
                        
                        <Select value={matchWith}
                                className='ml-0'
                                defaultValue={'Start with'}
                                onChange={(e) => setMatchWith(e.target.value)}>
                            <MenuItem key='Start with' value={'Start with'}>Start with</MenuItem>
                            {match.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                        </Select>
                    </div>
                      </div>
                  
                  {/*  <Chip style={{cursor:'pointer'}} label='Register your Trade Mark' color={"primary"} component={'a'} target={'_blank'}
                          href='https://www.khuranaandkhurana.com/trademark-requisition-form/' className='cursor-pointer mt-auto mb-auto ml-2 shadow-lg hover:shadow-sm'/>*/}

                </div>
            </div>
            <div className='h-4'/>

            <TMSearchResults
                trademarks={trademarks}
                loading={loading}
                wordmark={wordmark}
                searchedWordmark={searchedWordmark}
                count={count}
                offset={offset}
                limit={limit}
                openDetail={openDetail}
                onLoadMore={handleLoadMore}
            />
            <Dialog open={dialog} onClose={() => setDialog(false)}>
                <TMDetailSingle trademark={detailedTrademark}/>
            </Dialog>
        </div>
    )
}

export default TMSearch